module.exports = __webpack_public_path__ + "static/img/place_order.4e90cbf.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/icons/Help Page Icons/place_order.png
// module id = 353
// module chunks = 3